module.exports = __webpack_public_path__ + "static/pdn-sisterhood.853fce93.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/pages/pdn-sisterhood.pdf
// module id = 369
// module chunks = 174759553322802